import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000/api',
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    }
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

const GENERIC_ERROR_MESSAGE = 'Tuvimos un problema, volve a intentar mas tarde';

export const getApiErrorMessage = (error, fallback = GENERIC_ERROR_MESSAGE) => {
    const status = error?.response?.status;

    if (!error?.response || (status >= 500 && status <= 599)) {
        return GENERIC_ERROR_MESSAGE;
    }

    return error.response.data?.message || fallback;
};

export { GENERIC_ERROR_MESSAGE };

export default api;
